module.exports = __webpack_public_path__ + "files/95de9e5f13e39d1c9560584964c87d08.png";